import { useEffect, useState } from 'react'
import { ChildDaycareWithParents } from '@/types/Child'

export function usePriorityGroup(daycareChild: ChildDaycareWithParents) {
    const [selectedGroup, setSelectedGroup] = useState<string>(
        daycareChild.group ? daycareChild.group.groupId.toString() : ''
    )

    useEffect(() => {
        setSelectedGroup(daycareChild.group ? daycareChild.group.groupId.toString() : '')
    }, [daycareChild])

    return { selectedGroup, setSelectedGroup }
}
